import React from 'react';


import Carousel from '../pages/Carousel';
import { Helmet } from 'react-helmet';
import BenefitSection from '../pages/BenefitSection';
import ServiceSection from '../pages/ServiceSection';
import FunFactSection from '../pages/FunFactSection';
import TestimonialSection from '../pages/TestimonialSection';
import TeamSection from '../pages/TeamSection';
import FAQSection from '../pages/FAQSection';
import NewsSection from '../pages/NewsSection';
import PricingSection from '../pages/PricingSection';
import DestinationSection from '../pages/DestinationSection';
import GoogleAnalytics from './GoogleAnalytics';

const HeroSection = () => { // Rename Hero to HeroSection

    return (
        <div className=''>
          <GoogleAnalytics/>

            <Carousel/>
            <ServiceSection/>
            <PricingSection/>
            <BenefitSection/>
      <DestinationSection/>

            {/* <NewsSection/> */}
        <FunFactSection/>
        <TestimonialSection/>
        {/* <TeamSection/> */}
        <FAQSection/>
        
        </div>
    );
};

export default HeroSection; // Make sure to export the renamed component
